/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { createTheme, CssBaseline, Theme, ThemeProvider } from "@mui/material";

import { BrowserRouter } from "react-router-dom";
import { OidcProvider, OidcSecure } from "@axa-fr/react-oidc";
import { ConfigurationVariables } from "./config";
import React from "react";
import "./index.scss"; //was used for white theme
import "./App.scss"; // for white theme
import ShellNavigateBar from "./components/ShellNavigateBar/ShellNavigateBar";
import ThemeProviderWrapper from "./theme/theme-provider-wrapper/ThemeProviderWrapper";
import { Button, EmptyState } from "@forge/common";

import { LocalizationProvider, LocalizationConfig } from "@scuf/localization";
import { getFallbackLanguage, translation } from "./localization";

const LocalizationProviders = LocalizationProvider as any;
const LocalizationConfigWrap = LocalizationConfig as any;

export const configuration = {
  // IAM configuration
  client_id: ConfigurationVariables.FORGE_IAM_CLIENT_ID,
  redirect_uri: ConfigurationVariables.KONG_URL + "callback",
  scope: ConfigurationVariables.FORGE_IAM_SCOPE,
  authority: ConfigurationVariables.FORGE_IAM_AUTHORITY,
  response_type: "code",
};

const sessionLostComponent = () => {
  // window.location.href = "/login";

  return (
    <>
      <EmptyState
        description="Session lost due to inactivity.. Please login again to continue."
        title="Session lost..."
      >
        <Button
          iconPosition="left"
          onClick={function noRefCheck() {
            window.location.href = "/login";
          }}
          size="regular"
          variant="primary"
        >
          Go to Login
        </Button>
      </EmptyState>
    </>
  );
};
const loadingComponent = () => {
  return (
    <>
      <EmptyState title="Loading..."></EmptyState>
    </>
  );
};
const authenticatingComponent = () => {
  return (
    <>
      <>
        <EmptyState description={""} title={"Loading..."}></EmptyState>
      </>
    </>
  );
};
const callbackSuccessComponent = () => {
  return (
    <>
      <>
        <EmptyState
          description="Authenticated successfully. Redirecting to the application..."
          title="Login in progress..."
        ></EmptyState>
      </>
    </>
  );
};
function App() {
  const browserLang = window.navigator.language || "en";
  const fallbackLng = getFallbackLanguage(browserLang);

  return (
    <OidcProvider
      configuration={configuration}
      sessionLostComponent={sessionLostComponent}
      loadingComponent={loadingComponent}
      authenticatingComponent={authenticatingComponent}
      callbackSuccessComponent={callbackSuccessComponent}
    >
      <LocalizationConfigWrap languageCode={fallbackLng}>
        <LocalizationProviders translations={translation}>
          <BrowserRouter>
            <ThemeProviderWrapper>
              <OidcSecure>
                <ShellNavigateBar />
              </OidcSecure>
            </ThemeProviderWrapper>
          </BrowserRouter>
        </LocalizationProviders>
      </LocalizationConfigWrap>
    </OidcProvider>
  );
}

export default App;
